import React from "react";
import "../css/contacts.css";
// import ContactsCard from "../components/contact-card";
import ContactCard from "./ContactCard";
import Nav3d from "./navbarContact/nav";
import "../css/contactCard.css";
import Navbar from "../components/navbar";
const contacts = [
  {
    name: "Vatsal Chaudhary",
    post: "Head, Events & Competitions",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FVatsal(1).jpg?alt=media&token=791984b3-468c-4e6b-942f-1ad4d44b0c84",
    fb_userid: "https://www.facebook.com/vatsal.chaudhary.35977",
    phone: "+917985163578",
    gmail: "vatsal.chaudhary2001@gmail.com",
    ant_userid: "vatsal",
    linkedin: "https://www.linkedin.com/in/vatsal-chaudhary-459398183/",
    row: 1,
  },
  {
    name: "Shobhit Singh",
    post: "Head, Events & Competitions",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FShobhit.jpeg?alt=media&token=ac131c29-21ba-488a-b6fa-4b4079381f70",
    fb_userid: "https://www.facebook.com/profile.php?id=100009016034787",
    phone: "+918743943887",
    gmail: "singhshobhit304@gmail.com",
    ant_userid: "shobhit",
    linkedin: "https://www.linkedin.com/in/shobhit-singh-801/",
    row: 1,
  },
  {
    name: "Ajit Meena",
    post: "Head, Events & Competitions",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FAjit%20Meena%20Website%20(1).jpg?alt=media&token=b69ed73e-0509-4473-a897-706f66a3060bs://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FAjit%20Meena%20Website%20.jpg?alt=media&token=1c3a884c-d4a0-42bb-aa79-823b43c0ffee",
    fb_userid: "https://www.facebook.com/ajitm2608?mibextid=ZbWKwL",
    phone: "+917357455462",
    gmail: "",
    ant_userid: "ajit",
    linkedin: " https://www.linkedin.com/in/ajit-meena-b07a0b196",
    row: 1,
  },

  {
    name: "Sarthak Gupta",
    post: "Head, Finance",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2Fsarthak(1).jpeg?alt=media&token=f04d83bf-7769-4309-a883-2aa6339d55db",
    fb_userid: "https://www.facebook.com/sarthak.gupta.2991",
    phone: "+918306630350",
    gmail: "sarthak299g@gmail.com",
    ant_userid: "sarthak",
    linkedin: "https://www.linkedin.com/in/sarthak-gupta-653760197",
    row: 2,
  },

  {
    name: "Yash Burnwal",
    post: "Head, Marketing",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2Fyash.jpg?alt=media&token=e635c448-dbb9-467c-92d7-37a925accc73",
    fb_userid: "https://www.facebook.com/burnwalyash/",
    phone: "+918354833012",
    gmail: "byash.iitk@gmail.com",
    ant_userid: "yash",
    linkedin: "https://www.linkedin.com/in/yash-burnwal-4849281ba/",
    row: 3,
  },
  {
    name: "Dhruv Mittal",
    post: "Head, Marketing",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FDhruv%20mittal.jpg?alt=media&token=7636661e-c071-45ac-8572-29f5b246e466",
    fb_userid: "https://www.facebook.com/dhruv.mittal.73594",
    phone: "+919818898351",
    gmail: "dmittal2110@gmail.com",
    ant_userid: "dhruv",
    linkedin: "https://www.linkedin.com/in/dhruv-mittal-62065219a",
    row: 3,
  },

  {
    name: "Tanishka Agrawal",
    post: "Head, Media & Publicity",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FTanishka(1).jpg?alt=media&token=64384ecc-5bab-4fbe-9fa7-15de9c865bd2",
    fb_userid: "https://www.facebook.com/tanishka.agrawal.528",
    phone: "+917987921274",
    gmail: "agl29tani@gmail.com",
    ant_userid: "tanishka",
    linkedin: "https://www.linkedin.com/in/tanishka-agrawal-8b69051a7",
    row: 4,
  },
  {
    name: "Anand Patwa",
    post: "Head, Media & Publicity",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FAnand%20Patwa(1).jpeg?alt=media&token=c6c7df8e-6494-497b-b257-442f85214705",
    fb_userid: "https://www.facebook.com/anand.patwa.777/",
    phone: "+919421845539",
    gmail: "anand11072001@gmail.com",
    ant_userid: "anand",
    linkedin: "https://www.linkedin.com/in/anand-patwa-274632191/",
    row: 4,
  },

  {
    name: "Ridham Jain",
    post: "Head, Public Relations",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FRidham(1).jpeg?alt=media&token=48c74b05-0f54-49c7-97a1-5e49e4f165fe",
    fb_userid: "https://www.facebook.com/profile.php?id=100009074329116",
    phone: "+919166898463",
    gmail: "ridham@antaragni.in",
    ant_userid: "ridham",
    linkedin: "https://www.linkedin.com/in/ridham-jain-b857311b6/",
    row: 5,
  },
  {
    name: "Mohit Kumar",
    post: "Head, Public Relations",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FMohit.jpg?alt=media&token=8a71798c-f3e0-4566-a456-631a01242bba",
    fb_userid: "https://www.facebook.com/profile.php?id=100037413513684",
    phone: "+918929772823",
    gmail: "mohitdbg199@gmail.com",
    ant_userid: "mohit",
    linkedin: "https://www.linkedin.com/in/mohit-kumar-07734a1ab",
    row: 5,
  },

  {
    name: "Rishi Prakash",
    post: "Head, Security",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FRishi.jpg?alt=media&token=ac935ddf-3cfd-4aa2-b028-4144f5578817",
    fb_userid: "https://www.facebook.com/profile.php?id=100038051462788",
    phone: "+919801015858",
    gmail: "rishiprakash98@gmail.com",
    ant_userid: "rishi",
    linkedin: "http://linkedin.com/in/rishiroyz",
    row: 6,
  },
  {
    name: "Prathmesh Singh Dhakad",
    post: "Head, Security",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FPrathmesh(1).jpg?alt=media&token=cd6615e6-ab21-4ab3-b8c2-3f47e3a445e8",
    fb_userid: "https://www.facebook.com/prathmesh.singhdhakad/",
    phone: "+919630808590",
    gmail: "prathmeshdhakad@gmail.com",
    ant_userid: "prathmesh",
    linkedin: "https://www.linkedin.com/in/prathmesh-singh-dhakad-774828196/",
    row: 6,
  },

  {
    name: "Navshruti Singh",
    post: "Head, Show Management",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FNavshruti(1).jpg?alt=media&token=a7a98e8c-28e4-48a3-bfdf-d3473b6b63cb",
    fb_userid: "https://www.facebook.com/navshruti.singh.52",
    phone: "+917037893777",
    gmail: "singhnavshruti@gmail.com",
    ant_userid: "navshruti",
    linkedin: "https://www.linkedin.com/in/navshrutisingh/",
    row: 7,
  },
  {
    name: "Abhishek",
    post: "Head, Show Management",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FAbhishek(1).jpg?alt=media&token=1fe969cc-535b-4d55-a57d-c682091a3520",
    fb_userid: "https://www.facebook.com/abhitam8853",
    phone: "+918853875986",
    gmail: "abhishekg6377@gmail.com",
    ant_userid: "abhishekg",
    linkedin: "https://www.linkedin.com/in/abhishek-g-5696581aa",
    row: 7,
  },
  {
    name: "Mahesh Mandar",
    post: "Head, Show Management",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FMahesh.jpg?alt=media&token=e941cb43-f582-4410-a035-23b8d15b1672",
    fb_userid: "https://www.facebook.com/profile.php?id=100070061164279",
    phone: "+917073112199",
    gmail: "maheshmandar9@gmail.com",
    ant_userid: "maheshm",
    linkedin: "https://www.linkedin.com/in/mahesh-mandar-991321213",
    row: 7,
  },

  {
    name: "Navya Ratnan",
    post: "Head, Design",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2Fnavya.jpg?alt=media&token=3f2bc514-7282-4154-b044-ad08b8a0da07",
    fb_userid: "https://www.facebook.com/profile.php?id=100005155472642",
    phone: "+917593800951",
    gmail: "navyaratnan243@gmail.com",
    ant_userid: "navya",
    linkedin: "https://www.linkedin.com/in/navya-ratnan/",
    row: 8,
  },
  {
    name: "Granth Choudhary",
    post: "Head, Design",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FGranth_Choudhary.jpg?alt=media&token=b0c1f4b2-1389-4931-b905-f4701c88a36e",
    fb_userid: "https://www.facebook.com/granth.choudhary/",
    phone: "+918209967877",
    gmail: "granthchoudhary40@gmail.com",
    ant_userid: "granth",
    linkedin: "https://www.linkedin.com/in/granth-choudhary-a9199223a",
    row: 8,
  },
  {
    name: "Abhishek Rajwanshi",
    post: "Head, Design",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FAbhishek%20Rajwanshi(1).jpg?alt=media&token=b3ee4651-ba75-43ba-88cc-32753e2a7841",
    fb_userid: "https://www.facebook.com/abhishek.rajvanshi.39/",
    phone: "+919696174674",
    gmail: "rajwanshi2155501@gmail.com",
    ant_userid: "abhishekr",
    linkedin: "https://www.linkedin.com/in/abhishek-rajwanshi-3693421bb/",
    row: 8,
  },

  {
    name: "Sandeep Kumar",
    post: "Head, Web & App",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2Fsandeep.jpg?alt=media&token=910a5dbe-9613-4128-bab9-c0174b2c7a65",
    fb_userid: "https://facebook.com/sandeep.bijarnia.kumar",
    phone: "+918239850413",
    gmail: "sandeepskr1721@gmail.com",
    ant_userid: "admin",
    linkedin: "https://linkedin.com/in/sandeep-bijarnia-14812b201",
    row: 9,
  },
  {
    name: "Navneet Singh",
    post: "Head, Web & App",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2Fnavneet.jpeg?alt=media&token=7efff534-f9af-4340-ab28-963ebce2cb0d",
    fb_userid: "https://www.facebook.com/navneet2810/",
    phone: "+918546003658",
    gmail: "singhnavneet9640@gmail.com",
    ant_userid: "admin",
    linkedin: "https://www.linkedin.com/in/navneet-singh-0b849820b/",
    row: 9,
  },

  {
    name: "Mayank Sarwa",
    post: "Festival Coordinator",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2FmayankS.HEIC?alt=media&token=3dac2b59-2d02-4736-a084-020ce47ee059",
    fb_userid: "https://www.facebook.com/mayank.sarwa.180",
    phone: "+919079035719",
    gmail: "sarwamayank@gmail.com",
    ant_userid: "mayank",
    linkedin: "https://www.linkedin.com/in/mayank-sarwa/",
    row: 10,
  },
  {
    name: "Nikunj Mundhra",
    post: "Festival Coordinator",
    image:
      "https://firebasestorage.googleapis.com/v0/b/antaragniflame.appspot.com/o/ContactUs%2FSquare_Images%2Fnikunj(1).jpg?alt=media&token=c00e632f-44b0-444e-9d16-9869911a5553",
    fb_userid: "https://www.facebook.com/nikunj.mundhra.77",
    phone: "+918529779807",
    gmail: "mundhranikunj27@gmail.com",
    ant_userid: "nikunj",
    linkedin: "https://www.linkedin.com/in/nikunj-mundhra-467047a6",
    row: 10,
  },
];

export default function Contacts() {
  const contactList = Array([], [], [], [], [], [], [], [], [], []);
  const posts = Array(10);
  contacts.forEach((contact) => {
    contactList[contact.row - 1].push(contact);
    posts[contact.row - 1] = contact.post;
  });

  return (
    <div className="contactContainer">
      <div className="bgContact"></div>
      <Navbar />
      <div className="contactHeading">
        <h1>Contacts</h1>
      </div>
      <div className="contactNav">
        <Nav3d posts={posts} />
      </div>
      <div className="contactGrid">
        {contactList.map((contacts, index) => (
          <>
            <div id={index + 1} className="ConHeading">
              <h2>{contacts[0].post}</h2>
            </div>
            <ul className="cardscon">
              {contacts.map((contact) => (
                <ContactCard contact={contact} />
              ))}
            </ul>
          </>
        ))}
      </div>
    </div>
  );
}
